import { R } from '@/features/profile/resources/ProfileResources.resx';
import { Utils } from '@/shared/Utils';
import { FormErrorText, Button } from '@/components';
import { EditIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

type ModulusWarningProps = {
    cprNumber: string;
    onConfirm: () => void;
    onBack: () => void;
    isPending: boolean;
    errorMessage?: string;
};

export const ModulusWarning = ({
    cprNumber,
    onConfirm,
    onBack,
    isPending,
    errorMessage,
}: ModulusWarningProps) => {
    return (
        <section className="flex flex-col gap-4">
            <div className="rounded-2xl border border-gray-400 bg-gray-100 p-4">
                <EditIcon />
                <main>
                    <p className="font-bold">{R.ConfirmCprIsCorrectHeader}</p>
                    <p className="text-gray-900">
                        <span>{`${Utils.formatCpr(cprNumber)} `}</span>
                        {R.CprModulusCheckWarning}
                    </p>

                    {!!errorMessage && <FormErrorText message={errorMessage} />}
                </main>
            </div>

            <div className="flex justify-end gap-4">
                <Button variant="secondary" onClick={onBack}>
                    {R.Back}
                </Button>
                <Button
                    variant="primary"
                    className={cn({ 'button--loading': isPending })}
                    onClick={onConfirm}
                >
                    {R.ConfirmAndSave}
                </Button>
            </div>
        </section>
    );
};
